"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var rocketchat_socket_client_1 = __importDefault(require("@reaction-club/rocketchat-socket-client"));
var lodash_1 = __importDefault(require("lodash"));
var actions_1 = __importDefault(require("../actions"));
var fixMessageFields_1 = __importDefault(require("./helpers/fixMessageFields"));
var chatClient = new rocketchat_socket_client_1["default"]();
exports["default"] = {
    initSocket: function (_a) {
        var _this = this;
        var url = _a.url, userId = _a.userId, token = _a.token, verbose = _a.verbose;
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                dispatch(actions_1["default"].socketOpened());
                chatClient.connect(url);
                chatClient.on('connected', function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                dispatch(actions_1["default"].socketSetState(true));
                                return [4 /*yield*/, dispatch(this.initSubscriptions({ userId: userId, token: token, verbose: verbose }))
                                    // recover data after connection lost
                                    // dispatch(this.getCurrentRoomNewMessagesDebounced())
                                ];
                            case 1:
                                _a.sent();
                                // recover data after connection lost
                                // dispatch(this.getCurrentRoomNewMessagesDebounced())
                                dispatch(this.checkForUpdates());
                                return [2 /*return*/];
                        }
                    });
                }); });
                // chat.ddp.on('error', (e) => {
                //   console.log('error connect', e)
                // dispatch(actions.socketSetState(false))
                // })
                chatClient.on('disconnected', function () {
                    dispatch(actions_1["default"].socketSetState(false));
                });
                // delay for a moment we can start to show indication
                setTimeout(function () {
                    var isSocketOpen = getState().chat.isSocketOpen;
                    if (isSocketOpen)
                        dispatch(actions_1["default"].socketWarnings(true));
                }, 3000);
                return [2 /*return*/];
            });
        }); };
    },
    initSubscriptions: function (_a) {
        var _this = this;
        var token = _a.token, userId = _a.userId, verbose = _a.verbose;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, chatClient.login({ resume: token })
                        /*
                        stream-notify-logged => Deleted user, https://rocket.chat/docs/developer-guides/realtime-api/subscriptions/stream-notify-logged/
                        stream-notify-room => delete message, typing => https://rocket.chat/docs/developer-guides/realtime-api/subscriptions/stream-notify-room/
                        stream-room-messages =>
                         */
                        // chat.ddp.subscribe('stream-notify-user', `${userId}/notification`, false)
                    ];
                    case 1:
                        _a.sent();
                        /*
                        stream-notify-logged => Deleted user, https://rocket.chat/docs/developer-guides/realtime-api/subscriptions/stream-notify-logged/
                        stream-notify-room => delete message, typing => https://rocket.chat/docs/developer-guides/realtime-api/subscriptions/stream-notify-room/
                        stream-room-messages =>
                         */
                        // chat.ddp.subscribe('stream-notify-user', `${userId}/notification`, false)
                        chatClient.subscribe('stream-notify-user', userId + "/rooms-changed", false);
                        chatClient.on('stream-notify-user', function (data) { return __awaiter(_this, void 0, void 0, function () {
                            var _a, eventName, args, action, payload, event, _b, _id, t, 
                            // sysMsg, // before 1.14.2
                            // @ts-ignore temporary. No types for system messages
                            sysMes, msg, rid;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        _a = data.fields, eventName = _a.eventName, args = _a.args;
                                        action = args[0], payload = args[1];
                                        if (verbose)
                                            console.log('stream-notify-user', lodash_1["default"].cloneDeep(data));
                                        event = eventName.replace(/\w+\//, '');
                                        _b = event;
                                        switch (_b) {
                                            case 'rooms-changed': return [3 /*break*/, 1];
                                        }
                                        return [3 /*break*/, 5];
                                    case 1:
                                        _id = payload._id, t = payload.t, sysMes = payload.sysMes;
                                        if (verbose)
                                            console.log('rooms-changed', sysMes, lodash_1["default"].cloneDeep(payload));
                                        if (sysMes) {
                                            // 1.14.1 and below: // skip all system messages. It send wrong data that couldn't be used
                                            // 1.14.2 - fetch updates. probably new/deleted room
                                            dispatch(this.checkForUpdates());
                                            return [2 /*return*/, null];
                                        }
                                        if (!payload.lastMessage) return [3 /*break*/, 3];
                                        msg = fixMessageFields_1["default"](payload.lastMessage);
                                        rid = msg.rid;
                                        return [4 /*yield*/, dispatch(this.getRoom(rid))];
                                    case 2:
                                        _c.sent();
                                        dispatch(actions_1["default"].setMessages(rid, [msg]));
                                        dispatch(actions_1["default"].receivedNewMessages(msg));
                                        return [3 /*break*/, 4];
                                    case 3:
                                        if (verbose)
                                            console.log('chat message ignored', payload);
                                        _c.label = 4;
                                    case 4: return [3 /*break*/, 6];
                                    case 5:
                                        if (verbose)
                                            console.log('Error: RC event is not handler', event);
                                        _c.label = 6;
                                    case 6: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        }); };
    },
    reset: function () {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                dispatch(this.closeChat());
                return [2 /*return*/];
            });
        }); };
    },
    closeChat: function () {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                dispatch(actions_1["default"].socketWarnings(false));
                chatClient.close();
                dispatch(actions_1["default"].socketClose());
                return [2 /*return*/];
            });
        }); };
    }
};
